var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ByteuiButton from '../Button';
import Dropdown from './index';
import IconMore from '../../icon/react-icon/IconMore';
var positionList = [
    'top',
    'tl',
    'tr',
    'bottom',
    'bl',
    'br',
];
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, children = _a.children, droplist = _a.droplist, position = _a.position, trigger = _a.trigger, type = _a.type, icon = _a.icon, unmountOnExit = _a.unmountOnExit, onClick = _a.onClick, buttonProps = _a.buttonProps;
        return (React.createElement(ByteuiButton.Group, { className: className, style: style },
            React.createElement(ByteuiButton, __assign({ type: type, onClick: onClick }, buttonProps), children),
            React.createElement(Dropdown, { droplist: droplist, position: position, trigger: trigger, unmountOnExit: unmountOnExit },
                React.createElement(ByteuiButton, { type: type }, icon))));
    };
    Button.propTypes = {
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        style: PropTypes.object,
        position: PropTypes.oneOf(positionList),
        trigger: PropTypes.oneOf(['hover', 'click']),
        icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        type: PropTypes.string,
        unmountOnExit: PropTypes.bool,
    };
    Button.defaultProps = {
        style: {},
        position: 'br',
        trigger: 'hover',
        type: 'default',
        unmountOnExit: true,
        icon: React.createElement(IconMore, null),
    };
    return Button;
}(Component));
export default Button;
